document.addEventListener('alpine:init', () => {
  if (document.querySelector('[data-element="swiper-carousel"]')) {
    console.log('Swiper carousel is initialized');
  }
});
